import { getStartupParams } from 'helpers/startup-params.helper';
import { Translations } from './localization.helper.types';
import Config from '../config';

function getTemporaryTranslation(translationKey: string): string {
	//TODO add DefaultCashPointsName constant

	let translations = {
		'pickupDate.shortMonth.january': 'Jan',
		'pickupDate.shortMonth.february': 'Feb',
		'pickupDate.shortMonth.march': 'Mar',
		'pickupDate.shortMonth.april': 'Apr',
		'pickupDate.shortMonth.may': 'May',
		'pickupDate.shortMonth.june': 'Jun',
		'pickupDate.shortMonth.july': 'Jul',
		'pickupDate.shortMonth.august': 'Aug',
		'pickupDate.shortMonth.september': 'Sep',
		'pickupDate.shortMonth.october': 'Oct',
		'pickupDate.shortMonth.november': 'Nov',
		'pickupDate.shortMonth.december': 'Dec',
		'pickupDate.today': 'Today',
		'pickupDate.tomorrow': 'Tomorrow',
		payexPaymentName: 'Card',
		pickupPaymentName: 'Pick-up',
		vippsPaymentName: 'Vipps',
		stripePaymentName: 'Card',
		invoicePaymentName: 'Invoice',
		cashPointsPaymentNameTemplate: '{cashpointsName}',
		'restaurantSchedule.dayTitle': 'Weekday',
		'restaurantSchedule.deliveryTitle': 'Delivery',
		'restaurantSchedule.restaurantTitle': 'Restaurant',
		'restaurantSchedule.closed': 'Closed',
		'weekdaysShort.monday': 'Mon',
		'weekdaysShort.tuesday': 'Tue',
		'weekdaysShort.wednesday': 'Wed',
		'weekdaysShort.thursday': 'Thu',
		'weekdaysShort.friday': 'Fri',
		'weekdaysShort.saturday': 'Sat',
		'weekdaysShort.sunday': 'Sun',
		languageCodeSV: 'Swedish',
		languageCodeEN: 'English',
		languageCodeNB: 'Norwegian',
		languageCodeIS: 'Icelandic',
		order_status_delivered: 'Delivered',
		order_status_received: 'Received',
		order_status_confirmed: 'Confirmed',
		order_status_cancelled: 'Cancelled',

		'RestaurantPage.cartBlockTitle': 'Cart',
		'LogoutConfirmationPopup.title': 'Log out?',
		'LogoutConfirmationPopup.description':
			'If you log out you won\'t be able to receive push notifications relevant for your order',
		'RestaurantClosedErrorMessagePopup.title': 'Restaurant is closed',
		'RestaurantClosedErrorMessagePopup.tooBusyDescription':
			'We are currently experiencing a high volume of orders, please try again later',
		'RestaurantClosedErrorMessagePopup.closedDescription': 'Sorry, we are closed for orders from app',
		'RestaurantClosedErrorMessagePopup.buttonCaption': 'OK',
		'EmailAllReceiptsPopup.title': 'Email previous orders',
		'ResendPhoneCodeErrorMessage.buttonCaption': 'OK',
		'AboutPage.openingHoursBlockTitle': 'Opening hours',
		'AboutPage.locationBlockTitle': 'Location',
		'AboutPage.contactInfoBlockTitle': 'Contact info',
		'CartPage.orderDetailsBlockTitle': 'Order details',
		'CartPage.paymentBlockTitle': 'Payment',
		'CartPage.itemsBlockTitle': 'Items',
		'CartPage.alcoholDisclaimer': 'Purchase of Alcohol for minors will not be refunded',
		'CartPage.placeOrderButtonCaption': 'Place order',
		'PickupConfirmationPopup.title': 'Confirm order placement',
		'PickupConfirmationPopup.description':
			'Do you wish to place this order? Remember that you are economically responsible for your orders. Your phone number is {phone}',
		'VippsErrorMessagePopup.title': 'Vipps payment failed',
		'VippsErrorMessagePopup.buttonCaption': 'Continue ordering',
		'DiscountErrorMessagePopup.title': 'Cart',
		'DiscountErrorMessagePopup.buttonCaption': 'OK',
		'ErrorPage.messageBlockTitle': 'Error',
		'ErrorPage.buttonCaption': 'Reload app',
		'OrderPage.headerTitle': 'Your order is placed 👍',
		'OrderPage.headerDescription': 'Thanks for your purchase',
		'OrderPage.commentBlockTitle': 'Comment',
		'OrderPage.rateBlockTitle': 'Don’t forget to rate',
		'OrderPage.itemsBlockTitle': 'Items',
		'OrderPage.emailButtonCaption': 'Email order',
		'OrderPage.contactInfoBlockTitle': 'Contact info',
		'EmailReceiptPopup.title': 'Email order',
		'ErrorPage.restaurantNotSpecifiedMessage': 'Restaurant is not specified in url.',
		'BirthdayPopup.title': 'Birthday',
		'BirthdayPopup.cancelButtonCaption': 'Back',
		'BirthdayPopup.doneButtonCaption': 'Save',
		'CashpointsPopup.currentBlockTitle': 'Current',
		'CashpointsPopup.transactionsBlockTitle': 'Transactions',
		'ConfirmationPopup.cancelButtonCaption': 'No',
		'ConfirmationPopup.doneButtonCaption': 'Yes',
		'DeliveryAddressPopup.title': 'Delivery address',
		'DeliveryAddressPopup.cancelButtonCaption': 'Back',
		'DeliveryAddressPopup.doneButtonCaption': 'Continue',
		'EmailPopup.title': 'Email',
		'EmailPopup.cancelButtonCaption': 'Back',
		'EmailPopup.doneButtonCaption': 'Save',
		'EmailReceiptPopup.cancelButtonCaption': 'Cancel',
		'EmailReceiptPopup.doneButtonCaption': 'Send',
		'EmailReceiptPopup.subscribeConsentCheckboxCaption': 'Receive receipts on email',
		'EmailReceiptPopup.inputPlaceholder': 'email',
		'InitialPopup.defaultUserName': 'Guest',
		'ModifierGroupEditPopup.doneButtonCaption': 'Done',
		'NamePopup.title': 'Name',
		'NamePopup.cancelButtonCaption': 'Back',
		'NamePopup.doneButtonCaption': 'Save',
		'OffersPopup.title': 'My offers',
		'OffersPopup.description': 'Loyalty programmes and discount',
		'OfflinePopup.title': 'Your device lost connection',
		'OfflinePopup.description': 'We\'re trying to reconnect',
		'OrderCommentPopup.title': 'Comment',
		'OrderCommentPopup.cancelButtonCaption': 'Cancel',
		'OrderCommentPopup.doneButtonCaption': 'Add comment',
		'OrdersPopup.title': 'Orders',
		'OrdersPopup.emptyPlaceholder': 'No active orders or order history',
		'OrdersPopup.activeBlockTitle': 'Active',
		'OrdersPopup.previousBlockTitle': 'Previous',
		'OrdersPopup.sendPreviousToEmailButtonCaption': 'Send to email',
		'PhonePopup.title': 'Signup/login to order',
		'PhonePopup.description': 'To order please add your phone number.',
		'PhonePopup.cancelButtonCaption': 'Cancel',
		'PhonePopup.doneButtonCaption': 'Continue',
		'PickupTimePopup.pickupTitle': 'Pickup time',
		'PickupTimePopup.deliveryTitle': 'Delivery time',
		'PickupTimePopup.cancelButtonCaption': 'Cancel',
		'PickupTimePopup.doneButtonCaption': 'Done',
		'ProfilePopup.title': 'Profile',
		'ProfilePopup.notSelectedPickerCaption': 'Not selected',
		'ProfilePopup.generalBlockTitle': 'General',
		'ProfilePopup.discountsBlockTitle': 'Discounts',
		'PromocodeEditPopup.title': 'Add promocode',
		'PromocodeEditPopup.cancelButtonCaption': 'Cancel',
		'PromocodeEditPopup.doneButtonCaption': 'Validate',
		'SelectLanguagePopup.title': 'Select language',
		'SelectLanguagePopup.cancelButtonCaption': 'Cancel',
		'SelectLanguagePopup.doneButtonCaption': 'Done',
		'SelectLocationPopup.title': 'Select location',
		'SelectPaymentTypePopup.title': 'Select payment type',
		'SelectPaymentTypePopup.cancelButtonCaption': 'Cancel',
		'SelectPaymentTypePopup.doneButtonCaption': 'Done',
		'SettingsPopup.title': 'Settings',
		'SettingsPopup.generalBlockTitle': 'General',
		'StripeCardRegistrationPopup.title': 'Add new credit card',
		'StripeCardRegistrationPopup.doneButtonCaption': 'Add',
		'StripeCardRegistrationPopup.cancelButtonCaption': 'Cancel',
		'TableEditPopup.title': 'Table number',
		'TableEditPopup.title.enterTable': 'Enter table number',
		'TableEditPopup.title.enterRoom': 'Enter room number',
		'TableEditPopup.title.enterTableWithChair': 'Enter table with chair number',
		'TableEditPopup.title.enterLounge': 'Enter lounge number',
		'TableEditPopup.title.enterStand': 'Enter stand number',
		'TableEditPopup.title.enterSunbed': 'Enter sunbed number',
		'TableEditPopup.cancelButtonCaption': 'Cancel',
		'TableEditPopup.doneButtonCaption': 'Continue',
		'VerificationCodePopup.title': 'Enter verification code',
		'VerificationCodePopup.description': 'You have recived a 4 character code on {phoneNumber}',
		'VerificationCodePopup.cancelButtonCaption': 'Cancel',
		'VerificationCodePopup.doneButtonCaption': 'Continue',
		'VerificationCodePopup.resendButtonCaption': 'Resend',
		'VerificationCodePopup.termsConsentCheckboxCaption': 'I accept ',
		'VerificationCodePopup.termsLinkCaption': 'terms and conditions',
		'VerificationCodePopup.marketingConsentCheckboxCaption': 'Receive personal offers from {chainName}',
		'VippsPaymentFramePopup.title': 'Pay with Vipps',
		'ZipEditPopup.title': 'Zip',
		'ZipEditPopup.description': 'Please specify your zip to view restaurants which deliver to your area.',
		'ZipEditPopup.cancelButtonCaption': 'Back',
		'ZipEditPopup.doneButtonCaption': 'Continue',
		'CartDisplay.serviceFeeLabel': 'Service fee({percent}%)',
		'CartDisplay.subTotalLabel': 'Sub total (excl vat)',
		'CartDisplay.deliveryPriceLabel': 'Delivery',
		'CartDisplay.discountLabel': 'Discount',
		'CartDisplay.tipLabel': 'Tip',
		'CartDisplay.vatLabel': 'VAT',
		'CartDisplay.totalLabel': 'Total',
		'CheckoutButton.buttonCaption': 'Go to checkout',
		'CheckoutButton.emptyCartButtonCaption': 'Empty cart',
		'ContactInfo.description':
			'If you have allergies or other dietary restrictions, please contact us. We’ll provide food-speicifc information upon request',
		'ContactInfo.phoneLabel': 'Phone',
		'ContactInfo.addressLabel': 'Address',
		'ContactInfo.websiteLabel': 'Website',
		'DeliveryCaption.timePriceTemplate': '{time} min · {price}',
		'DeliveryCaption.timeTemplate': '{time} min',
		'EntryCard.addToCartButtonCaption': 'Add to cart',
		'EntryCard.soldOutButtonCaption': 'Sold out',
		'EntryEdit.amountLabel': 'Amount: {quantity}',
		'EntryEdit.modifierNotSelectedValue': 'Not selected',
		'HistoryOrderList.orderedTimeText': 'Ordered {date}',
		'LocationList.deliveryConditionPriceLabel': 'Price of delivery is {price}.',
		'LocationList.deliveryConditionMinAmountLabel': 'Minimum order amount for delivery is {minAmount}.',
		'MinicartTrigger.cartCaption': 'Cart',
		'OrderDetails.tableNumberLabel': 'Table number',
		'OrderDetails.tableNumberNotSelectedPickerCaption': 'Enter table number',
		'OrderDetails.enterTable': 'Table number',
		'OrderDetails.enterRoom': 'Room number',
		'OrderDetails.enterTableWithChair': 'Table with chair number',
		'OrderDetails.enterLounge': 'Lounge number',
		'OrderDetails.enterStand': 'Stand number',
		'OrderDetails.enterSunbed': 'Sunbed number',
		'OrderDetails.enterTableNotSelectedPickerCaption': 'Enter table number',
		'OrderDetails.enterRoomNotSelectedPickerCaption': 'Enter room number',
		'OrderDetails.enterTableWithChairNotSelectedPickerCaption': 'Enter table with chair number',
		'OrderDetails.enterLoungeNotSelectedPickerCaption': 'Enter lounge number',
		'OrderDetails.enterStandNotSelectedPickerCaption': 'Enter stand number',
		'OrderDetails.enterSunbedNotSelectedPickerCaption': 'Enter sunbed number',
		'OrderDetails.pickupTimeLabel': 'Pickup time',
		'OrderDetails.deliveryTimeLabel': 'Delivery time',
		'OrderDetails.pickupTimeNotSelectedPickerCaption': 'Select time',
		'OrderDetails.deliveryAddressLabel': 'Delivery address',
		'OrderDetails.deliveryAddressNotSelectedPickerCaption': 'Add address',
		'OrderDetails.commentLabel': 'Comment',
		'OrderDetails.commentNotSelectedPickerCaption': 'Add comment',
		'OrderDetails.cutleryLabel': 'Number of people (Cutlery)',
		'OrderDetails.cutleryNotSelectedPickerCaption': 'Not selected',
		'OrderInfo.statusLabel': 'Status',
		'OrderInfo.readyTimeLabel': 'Order ready at',
		'OrderInfo.paidLabel': 'Paid with',
		'OrderInfo.notPaidLabel': 'Will be paid with',
		'OrderInfo.pickUpPlaceLabel': 'Pick-up',
		'OrderInfo.orderIdLabel': 'Order id',
		'OrderStatusBadge.cancelledCaption': 'Cancelled',
		'OrderStatusBadge.receivedCaption': 'Received',
		'OrderStatusBadge.confirmedCaption': 'Confirmed',
		'OrderStatusBadge.deliveredCaption': 'Delivered',
		'OrderTypeSelect.pickupLabel': 'Pickup',
		'OrderTypeSelect.deliveryLabel': 'Delivery',
		'OrderTypeSelect.dineinLabel': 'Dine-in',
		'PaymentDetails.paymentTypeLabel': 'Payment type',
		'PaymentDetails.paymentTypeNotSelectedPickerCaption': 'Select payment type',
		'PaymentDetails.cashpointsCheckboxCaption': 'Use {availableAmount} {cashpointsName}',
		'PaymentDetails.promocodeLabel': 'Promocode',
		'PaymentDetails.promocodeNotSelectedPickerCaption': 'Add promo code',
		'PaymentDetails.tipLabel': 'Add tip',
		'PickupCaption.timeTemplate': '{time} min',
		'ProfileDiscounts.offersLabel': 'My offers',
		'ProfileDiscounts.offersValue': '{count} Active',
		'ProfileGeneral.phoneLabel': 'Phone number',
		'ProfileGeneral.nameLabel': 'Name',
		'ProfileGeneral.emailLabel': 'Email',
		'ProfileGeneral.birthdayLabel': 'Birthday',
		'ProfileGeneral.creditCardLabel': 'Credit cards',
		'ProfileNavigation.editProfileLabel': 'Edit profile',
		'ProfileNavigation.settingsLabel': 'Settings',
		'ProfileSummary.myOffersCaption': 'My offers',
		'ProfileSummary.ordersLabel': 'Orders',
		'QuickEntryCard.soldOutLabel': 'Sold out',
		'Rate.title': 'How was your experience?',
		'RestaurantNavigation.ordersLabel': 'Orders',
		'RestaurantNavigation.profileLabel': 'Profile',
		'RestaurantNavigation.buddyLabel': 'Buddy',
		'SettingsFooter.logOutCaption': 'Log out',
		'SettingsFooter.termsConditionsCaption': 'Terms & conditions',
		'SettingsGeneral.languageLabel': 'Language',
		'SettingsGeneral.notificationsLabel': 'Notifications',
		'SettingsGeneral.notificationsValue': '{notificationCount} active',
		'LocationCard.deliveryDisabledLabel': 'Delivery not available',
		'LocationCard.deliveryHoursLabel': 'Delivery {startDelivery} - {stopDelivery}',
		'LocationCard.openLabel': 'Open',
		'LocationCard.closedLabel': 'Closed',
		'LocationCard.openHoursLabel': 'Open {startPickup} - {stopPickup}',
		'ModifierValidationErrorMessagePopup.title': 'Wrong modifiers',
		'ModifierValidationErrorMessagePopup.description': 'For {modifierName} you must select at least {minQuantity}',
		'ModifierValidationErrorMessagePopup.buttonCaption': 'OK',
		'NotificationsPopup.title': 'Notifications',
		'NotificationsPopup.description':
			'Configure notifications. Push notifcations relevant for your on-going orders won’t be affected',
		'NotificationsPopup.emailMarketingConsentCheckboxCaption': 'Receive promotional E-mails',
		'NotificationsPopup.smsMarketingConsentCheckboxCaption': 'Receive promotional SMS',
		'OrderStatusBadge.inProgressCaption': 'In progress',
		order_status_in_progress: 'In progress',
		'CardStatusPopup.title': 'Credit card',
		'CardStatusPopup.description': 'Current credit card {cardNumber}',
		'CardStatusPopup.cancelButtonCaption': 'Cancel',
		'CardStatusPopup.doneButtonCaption': 'Remove and add new',
		'IncompatibleCartConfirmationPopup.title': 'Empty cart?',
		'IncompatibleCartConfirmationPopup.description':
			'You can only purchase from one category per order. You have items from a different category in the cart, remove these?',
		'SendOrderErrorMessagePopup.title': 'Order wasn\'t placed',
		'SendOrderErrorMessagePopup.buttonCaption': 'OK',
		'CardPaymentConfirmationPopup.title': 'Confirm order placement',
		'CardPaymentConfirmationPopup.description': 'Do you wish to place this order? Your card number is {cardNumber}',
		'TermsPopup.title': 'Terms & Conditions',
		'TermsPopup.description': 'Thank you for being a {restaurant} customer. To continue you must accept our ',
		'TermsPopup.termsConsentCheckboxCaption': 'I accept ',
		'TermsPopup.termsLinkCaption': 'terms and conditions',
		'TermsPopup.marketingConsentCheckboxCaption': 'Receive personal offers from {chainName}',
		'TermsPopup.doneButtonCaption': 'Continue',
		'TermsPopup.cancelButtonCaption': 'Cancel',
		'OffersPopup.emptyPlaceholder': 'No active offers',
		languageCodeFI: 'Finnish',
		languageCodeDE: 'German',
		'OrderDetails.pickupLocationLabel': 'Ordering from',
		'CartPage.headerTitle': 'Checkout',
		'SelectLocationPopup.permissionButtonCaption': 'Find nearest location',
		'LocationPermissionConfirmationPopup.title': 'Geolocation',
		'LocationPermissionConfirmationPopup.description':
			'To determine which of our locations are closest to you we need access to your location.',
		'PickupTime.asapTemplate': 'As soon as possible (~{expectedWait} min)',
		order_status_purchased: 'Purchased',
		'ModifierGroupEditPopup.closeButtonCaption': 'Close',
		'ModifierGroupEditPopup.nextButtonCaption': 'Next',
		'ModifierGroupEditPopup.addToCartButtonCaption': 'Add to cart',
		'AddToHomeScreenPopup.description': 'Enjoying the experience? Remember you can always save us to your homescreen to get easy access.',
		'AddToHomeScreenPopup.installButtonCaption': 'Add now',
		'AddToHomeScreenPopup.iosInstallInstructionLabel': 'Tap {moreIcon} then {addToHomeScreenMenuItemName}',
		'AddToHomeScreenPopup.iosAddToHomeScreenMenuItemName': 'add to home screen',
		'SettingsGeneral.addToHomeScreenLabel': 'Save app to home screen',
		'ProfileNavigation.installButtonCaption': 'Add to home screen',
		languageCodeDA: 'Danish',
		'freePurchasePaymentName': 'Pick-up',
		'PaymentDetails.roundUpButtonCaption': 'Round up to {amount}',
		'ServerPopup.doneButtonCaption': 'OK',
		'EntryAllergens.label': 'Allergens',
		'AllergensPopup.doneButtonCaption': 'OK',
		'AllergensPopup.title': 'Allergens',
		'ModifierDescription.title': 'Description',
		'ModifierDescription.doneButtonCaption': 'OK',
		'CartDisplay.deliveryVatLabel': 'Delivery VAT ({percent}%)',
		'CartItemReadonly.vatLabel': 'VAT ({percent}%)',
		'OrderPage.repeatOrderButtonCaption': 'Order same again',
		'RepeatOrderConfirmation.title': 'Repeat order',
		'RepeatOrderConfirmation.description': 'You will order be ordering {orderingType} from {restaurantName}. Continue?',
		'RepeatOrderConfirmation.pickupTypeName': 'takeaway',
		'RepeatOrderConfirmation.deliveryTypeName': 'delivery',
		'RepeatOrderConfirmation.dineInTypeName': 'dine-in',
		'RepeatOrderMessage.buttonCaption': 'OK',
		'CartPage.emptyPlaceholder': 'Your cart is empty',
		'SelectPaymentTypePopup.emptyPlaceholder': 'No payment type is available',
		'ActiveOrderList.repeatOrderButtonCaption': 'Order same again',
		'HistoryOrderList.repeatOrderButtonCaption': 'Order same again',
		'RepeatOrderErrorMessagePopup.title': 'Repeat order failed',
		'RepeatOrderErrorMessagePopup.buttonCaption': 'OK',
		'OrderInfo.placedAtLabel': 'Placed at',
		'mobilePayPaymentName': 'Mobile Pay',
		'MobilePayOrderCancelledErrorMessagePopup.title': 'Payment cancelled',
		'MobilePayOrderCancelledErrorMessagePopup.buttonCaption': 'OK',
		'MobilePayReturnNoStateErrorMessagePopup.title': "Mobile Pay Return Error",
		'MobilePayReturnNoStateErrorMessagePopup.description': "Looks like you are not logged in. You can log in and review your order in 'My Orders' screen.",
		'MobilePayReturnNoStateErrorMessagePopup.buttonCaption': "Open 'My Orders'",
		'MobilePayReturnNoUrlErrorMessagePopup.title': "Mobile Pay Return Error",
		'MobilePayReturnNoUrlErrorMessagePopup.description': "It looks like you have unfinished payment in MobilePay app. You may want to return and finish it.",
		'MobilePayReturnNoUrlErrorMessagePopup.description2': "Did you already finish the payment? Then go to 'Orders' in this page instead.",
		'MobilePayReturnNoUrlErrorMessagePopup.buttonCaption': "OK",
		'OrdersPopup.emptyNotLoggedInPlaceholder': 'You must be logged in to view orders',
		'OrdersPopup.loginButtonCaption': 'Log in',
		'MobilePayInitErrorMessagePopup.title': 'Error',
		'MobilePayInitErrorMessagePopup.buttonCaption': 'OK',
		'AdyenCardRegistrationPopup.doneButtonCaption': 'Add',
		'AdyenCardRegistrationPopup.cancelButtonCaption': 'Cancel',
		'AdyenCardRegistrationPopup.addNewCreditCard': 'Add new credit card',
		'adyenCardPaymentName': 'Card',
		'AdyenCardCheckPaymentErrorMessagePopup.title': 'Error',
		'AdyenCardCheckPaymentErrorMessagePopup.buttonCaption': "OK",
		'AdyenCardRegistrationPopup.confirmCVC': 'Confirm CVC',
		'AdyenCardRegistrationPopup.currentCardNumber': 'Your card number is {cardNumber}',
		'AdyenCardRegistrationPopup.confirmButtonCaption': 'Confirm',
		'swishPaymentName': 'Swish',
		'SwishPayPopup.title': 'Pay with Swish',
		'SwishPayPopup.cancelButtonCaption': 'Cancel',
		'SwishPayCheckPaymentErrorMessagePopup.title': 'Error',
		'SwishPayCheckPaymentErrorMessagePopup.buttonCaption': "OK",
		'CauthClearCustomerDataPopup.title': 'Your data has been cleared',
		'CauthClearCustomerDataPopup.description': 'The authentication process failed. Your device has been registered again. You may need to verify your phone number.',
		'CauthClearCustomerDataPopup.doneButtonCaption': 'OK',
		'SlowServicePopup.description': 'Dear guest, we are unfortunately experiencing high load on the kitchen, so orders might take longer than usual. We appreciate your understanding!',
		'SlowServicePopup.doneCaption': 'OK',
		'AdyenMobilePayAnonymousPopup.title': 'Not logged in',
		'AdyenMobilePayAnonymousPopup.description': 'Looks like you have been redirected to the default browser where you are not logged into your account. Please switch to the browser in which you initiated the order, and find your order in the order history. ',
		'AdyenMobilePayAnonymousPopup.doneButtonCaption': 'OK',
		'ReCaptcha.error': 'Error! Recaptcha failed to verify.',
        'AdyenGooglePayPopup.title': 'Pay with Google Pay',
        'googlePayPaymentName': 'GooglePay',
        'GooglePayCheckPaymentErrorMessagePopup.title': 'Error',
        'GooglePayCheckPaymentErrorMessagePopup.buttonCaption': 'OK',
        'AdyenApplePayPopup.title': 'Pay with Apple Pay',
        'applePayPaymentName': 'ApplePay',
        'ApplePayCheckPaymentErrorMessagePopup.title': 'Error',
        'ApplePayCheckPaymentErrorMessagePopup.buttonCaption': 'OK',
		'GuestOrderPopup.title': 'Finalize order',
		'GuestOrderPopup.cancelButtonCaption': 'Cancel',
		'GuestOrderPopup.doneButtonCaption': 'Continue',
		'GuestOrderPopup.customerCardTitle': 'Are you a regular-customer?',
		'GuestOrderPopup.customerCardDescription': 'Get access to extra perks by signing in',
		'GuestOrderPopup.login': 'Login',
		'GuestOrderPopup.signup': 'Signup',
		'GuestOrderPopup.or': 'Or',
		'GuestOrderPopup.guestCardTitle': 'Order as a guest',
		'GuestOrderPopup.guestCardNameLabel': 'Name',
		'GuestOrderPopup.guestCardNameLabelDescription': 'Name we will use to call you',
		'GuestOrderPopup.guestCardPhoneLabel': 'Phone number',
		'GuestOrderPopup.guestCardPhoneLabelDescription': ' We will contact you by phone only if we need to inform you about your order',
		'GuestOrderPopup.termsConsentCheckboxCaption': 'I accept ',
		'GuestOrderPopup.termsLinkCaption': 'terms and conditions',
		'Success.ableToDeliver': 'Yes, we are able to deliver to your address',
		'Guest.incorrectPhone': 'Please provide a valid phone number to proceed',
		'Guest.termsMustBeAccepted': 'Please accept the terms and conditions to proceed',
		'Guest.nameMustBeEntered': 'Please enter your name to proceed',
		'RegularCustomer.areYouARegularCustomer': 'Are you a regular customer?',
		'RegularCustomer.getExtraPerks': 'Get access to extra perks by signing up / signing in.',
		'InitialOrderPopup.login': 'Login',
		'InitialOrderPopup.continueLogin': 'Continue',
		'InitialOrderPopup.signUp': 'Signup',
		'InitialOrderPopup.signupCardTitle': 'Are you a regular customer? Create an account',
		'InitialOrderPopup.signupCardDescription': 'Get extra perks by signing up',
	};

	return translations[translationKey] || null;
}

export const getSafeTranslation = (translationKey: string, translations: Translations): string => {
	const fallbackTranslation = getTemporaryTranslation(translationKey) || `{${translationKey}}`;
	if (!translations) {
		return fallbackTranslation;
	}

	if (!translations[translationKey]) {
		return fallbackTranslation;
	}

	return translations[translationKey];
};

export const getPhoneCodeForFullLocale = (phoneCodes, fullLocale) => {
	const defaultPhoneCode = phoneCodes.find(phoneCode => phoneCode.isDefault);
	if (!fullLocale) {
		return defaultPhoneCode;
	}

	const codeByLocale = phoneCodes.find(phoneCode =>
		phoneCode.locales.find(locale => locale.toLowerCase() === fullLocale.toLowerCase())
	);

	return codeByLocale ? codeByLocale : defaultPhoneCode;
};

export const getBrowserFullLocale = () => {
	return window.navigator.language || Config.defaultLanguage;
};

export const getBrowserShortLocaleAdaptedForBackend = language => {
	if (!language) {
		return null;
	}

	language = language.split('-')[0];

	const norwegianDialects = ['nb', 'nn', 'no'];

	return norwegianDialects.includes(language) ? 'nb' : language;
};

export const getCalculatedGlobalShortLocale = customer => {
	const localeFromUrl = getStartupParams().locale;
	if (localeFromUrl) {
		return localeFromUrl;
	}

	if (customer && customer.currentCustomer && customer.currentCustomer.locale) {
		return customer.currentCustomer.locale;
	}

	return getBrowserShortLocaleAdaptedForBackend(getBrowserFullLocale());
};
